<template lang="pug">
.home
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { UserRoles } from '@/const/UserRoles'

@Component
export default class Home extends Vue {
  private mounted() {
    // クッキーの権限情報によって遷移先振り分け
    const userRole = this.$bcbtCookies.authBcbt.get()?.currentApiUserRole
    switch (userRole) {
      case UserRoles.ADMIN:
        // システム管理者権限
        this.$router.push({ name: 'AdminAcademyManagement' })
        break
      case UserRoles.ACADEMY:
        // 塾管理者権限
        this.$router.push({ name: 'AcademyStudyManagement' })
        break
      case UserRoles.BRANCH:
      case UserRoles.TEACHER:
        // 教室長・講師権限
        this.$router.push({ name: 'BranchStudyManagement' })
        break
      case UserRoles.STUDENT:
        // 生徒権限
        this.$router.push({ name: 'StudentStudySelection' })
        break
      default:
        // 上記以外は生徒ログインへ遷移
        this.$router.push({ name: 'StudentLogin' })
    }
  }
}
</script>
